import { map, Observable } from 'rxjs';

/** Envelope returned by most admin endpoints. */
export interface ApiResponse<T> {
  success: boolean;
  message: string;
  data: T;
  errors: Record<string, string[]> | null;
}

/** Laravel paginator shape returned by list endpoints. */
export interface Paginated<T> {
  data: T[];
  links: {
    first: string | null;
    last: string | null;
    prev: string | null;
    next: string | null;
  };
  meta: {
    current_page: number;
    from: number | null;
    last_page: number;
    per_page: number;
    to: number | null;
    total: number;
    path: string;
    links: Array<{
      url: string | null;
      label: string;
      page: number | null;
      active: boolean;
    }>;
  };
}

/** Pipe operator to unwrap the {success, data, ...} envelope. */
export function unwrap<T>() {
  return (source: Observable<ApiResponse<T>>): Observable<T> =>
    source.pipe(map((r) => r.data));
}
